module.exports = __webpack_public_path__ + "img/404-2.b7ebb57b.png";